import './style.css'
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import gsap from "gsap";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import sources from './sources';
import logo from "./thinkmoto.png";

/**
 * Settings Bot
 */
document.getElementById("logo").setAttribute("src", logo);

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
let renderer;

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Lights
 */
const light = new THREE.AmbientLight( 0x404040 ); // soft white light
scene.add( light ); 
const directionalLight = new THREE.DirectionalLight( 0xffffff, 2.0 );
directionalLight.position.set(1,1,1)
scene.add( directionalLight );
const pointlight = new THREE.PointLight( 0xf07f13, 10, 100 );
pointlight.position.set( 0, 0, 0 );
scene.add( pointlight );


window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // controls
    if (window.innerWidth <= 600) {
        controls.enableDamping = false
        controls.enablePan = false
        controls.enableRotate = true
    } else {
        controls.enableDamping = false
        controls.enablePan = false
        controls.enableRotate = false
    }
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 30
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)

if (window.innerWidth <= 600) {
    controls.enableDamping = false
    controls.enablePan = false
    controls.enableRotate = true
} else {
    controls.enableDamping = false
    controls.enablePan = false
    controls.enableRotate = false
}

controls.minDistance = 0;
controls.maxDistance = 30;

/*
 * Sources
 */
const gltfLoader = new GLTFLoader();
const textureLoader = new THREE.TextureLoader();
let textures = []
let models = []
let loaded = 0
let bgTexture;
const toLoad = sources.length
for (const source of sources) {
    if (source.type === 'texture') {
        bgTexture = textureLoader.load(source.path, (texture) => {
            textures.push(texture)
            sourceLoaded()
        })
    } else if (source.type === 'gltf') {
        gltfLoader.load(source.path, (model) => {
            models.push(model.scene)
            sourceLoaded()
        })
    } else if (source.type === 'spidernet') {
        document.getElementById('spidernet').src = source.path,
        textureLoader.load(source.path, (spidernet) => {
            sourceLoaded()
        })
    }
}

const sourceLoaded = () => {
    loaded++;
    if (loaded === toLoad) {
        init();
    }
}

const init = () => {
    document.body.style.opacity = 1;
    /**
     * Mouse move
     */
    let mouse = new THREE.Vector2();
    window.addEventListener('mousemove', (event) => {
        event.preventDefault();
        mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;

        models[0].rotation.y = THREE.MathUtils.lerp(models[0].rotation.y, (mouse.x * Math.PI) / 10, 0.9)
        models[0].rotation.x = THREE.MathUtils.lerp(models[0].rotation.x, (-mouse.y * Math.PI) / 10, 0.9)        
    })

    /**
     * Mouse Move
     */
    let mouseClick = new THREE.Vector2(0,0);
    let raycaster = new THREE.Raycaster();
    window.addEventListener('click', (e) =>
    {
        e.preventDefault;
        var rect = renderer.domElement.getBoundingClientRect();
        mouseClick.x = ( ( e.clientX - rect.left ) / rect.width ) * 2 - 1;
        mouseClick.y = - ( ( e.clientY - rect.top ) / rect.height ) * 2 + 1;

        raycaster.setFromCamera(mouseClick, camera);
        var intersects = raycaster.intersectObject(models[0].children[0]);
        
        if (intersects.length > 0) {
            gsap.to(customUniforms.uSeparation, {
                value: 0.2,
                duration: 0.4,
                repeat:1,
                yoyo:true
            })
            gsap.to(models[0].rotation, {
                y: -2. * Math.PI,
                duration: 0.5,
            })
        } else {
            gsap.to(customUniforms.uSeparation, {
                value: 0.0,
                duration: 0.2,
            })
            gsap.to(models[0].rotation, {
                y: 0,
                duration: 0.5,
            })
        }
    })

    /**
     * Pumpkin
     */
    const customUniforms = {
        uTime: {value: 0},
        progress: {value: 0},
        uSeparation: {value: 0}
    }

    models[0].children[0].material.onBeforeCompile = (shader) => {
         // Custom Uniforms
        shader.uniforms.uTime = customUniforms.uTime;
        shader.uniforms.progress = customUniforms.progress;
        shader.uniforms.uSeparation = customUniforms.uSeparation;

        shader.vertexShader = shader.vertexShader.replace(
            '#include <common>',
            `
                #include <common>
                uniform float uTime;
                uniform float uSeparation;
                uniform float progress;
                attribute float aRandom;
                attribute vec3 aCenter;

                mat4 rotationMatrix(vec3 axis, float angle) {
                    axis = normalize(axis);
                    float s = sin(angle);
                    float c = cos(angle);
                    float oc = 1.0 - c;
                    
                    return mat4(oc * axis.x * axis.x + c,           oc * axis.x * axis.y - axis.z * s,  oc * axis.z * axis.x + axis.y * s,  0.0,
                                oc * axis.x * axis.y + axis.z * s,  oc * axis.y * axis.y + c,           oc * axis.y * axis.z - axis.x * s,  0.0,
                                oc * axis.z * axis.x - axis.y * s,  oc * axis.y * axis.z + axis.x * s,  oc * axis.z * axis.z + c,           0.0,
                                0.0,                                0.0,                                0.0,                                1.0);
                }
                
                vec3 rotate(vec3 v, vec3 axis, float angle) {
                    mat4 m = rotationMatrix(axis, angle);
                    return (m * vec4(v, 1.0)).xyz;
                }
            `
        )
        shader.vertexShader = shader.vertexShader.replace(
            '#include <begin_vertex>',
            `
                #include <begin_vertex>

                float prog = (position.y + 1.) / 2.;
                float locprog = clamp((progress - 0.4 * prog) / 0.9, 0., 1.);
            
                transformed = rotate(position, vec3(0.0, 1.0, 0.0), aRandom * locprog *3.14*3.);

                
                transformed *= (1. + locprog);
                transformed += normal * uSeparation;
            `
        )
    }

    let len = models[0].children[0].geometry.attributes.position.count;
    let randoms = new Float32Array(len);
    let centers = new Float32Array(len * 3);
    for (let i = 0; i < len; i+=3) {
        let r = Math.random();
        randoms[i] = r;
        randoms[i+1] = r;
        randoms[i+2] = r;

        let x = models[0].children[0].geometry.attributes.position.array[i*3];
        let y = models[0].children[0].geometry.attributes.position.array[i*3+1];
        let z = models[0].children[0].geometry.attributes.position.array[i*3+2];
        
        let x1 = models[0].children[0].geometry.attributes.position.array[i*3+3];
        let y1 = models[0].children[0].geometry.attributes.position.array[i*3+4];
        let z1 = models[0].children[0].geometry.attributes.position.array[i*3+5];

        let x2 = models[0].children[0].geometry.attributes.position.array[i*3+6];
        let y2 = models[0].children[0].geometry.attributes.position.array[i*3+7];
        let z2 = models[0].children[0].geometry.attributes.position.array[i*3+8];

        let center = new THREE.Vector3(x, y, z).add(new THREE.Vector3(x1, y1, z1)).add(new THREE.Vector3(x2,y2,z2)).divideScalar(3);
        centers.set([center.x, center.y, center.z], i*3);
    }
    models[0].children[0].geometry.setAttribute('aRandom', new THREE.BufferAttribute(randoms, 1));
    models[0].children[0].geometry.setAttribute('aCenter', new THREE.BufferAttribute(centers, 3));

    models[0].scale.set(30, 30, 30)
    models[0].position.set(0, -5, 0)
    scene.add(models[0])

    /**
     * Fireflies
     */
    let fireflyGeometry = new THREE.BufferGeometry();
    let fireflynumber = 100;
    let vertices = [];
    for ( let i = 0; i < fireflynumber; i ++ ) {
        const x = THREE.MathUtils.randFloatSpread( 30 );
	    const y = THREE.MathUtils.randFloatSpread( 30 );
	    const z = THREE.MathUtils.randFloatSpread( 30 );

        vertices.push( x, y, z );
    }
    fireflyGeometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
    const fireflyMaterial = new THREE.PointsMaterial({
        size: 0.2,
        sizeAttenuation: true,
        // alphaTest: 0.5,
        transparent: true,
        color: 0xfddba3,
    });
    fireflyMaterial.onBeforeCompile = (shader) => {
        shader.uniforms.uTime = customUniforms.uTime;
        shader.vertexShader = shader.vertexShader.replace(
            '#include <common>',
            `
                #include <common>
                uniform float uTime;

                vec3 mod289(vec3 x) {
                    return x - floor(x * (1.0 / 289.0)) * 289.0;
                }
                
                vec2 mod289(vec2 x) {
                    return x - floor(x * (1.0 / 289.0)) * 289.0;
                }
                
                vec3 permute(vec3 x) {
                    return mod289(((x*34.0)+1.0)*x);
                }
                
                float noise(vec2 v)
                {
                    const vec4 C = vec4(0.211324865405187,  // (3.0-sqrt(3.0))/6.0
                                      0.366025403784439,  // 0.5*(sqrt(3.0)-1.0)
                                     -0.577350269189626,  // -1.0 + 2.0 * C.x
                                      0.024390243902439); // 1.0 / 41.0
                    // First corner
                    vec2 i  = floor(v + dot(v, C.yy) );
                    vec2 x0 = v -   i + dot(i, C.xx);
                
                    // Other corners
                    vec2 i1;
                    //i1.x = step( x0.y, x0.x ); // x0.x > x0.y ? 1.0 : 0.0
                    //i1.y = 1.0 - i1.x;
                    i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
                    // x0 = x0 - 0.0 + 0.0 * C.xx ;
                    // x1 = x0 - i1 + 1.0 * C.xx ;
                    // x2 = x0 - 1.0 + 2.0 * C.xx ;
                    vec4 x12 = x0.xyxy + C.xxzz;
                    x12.xy -= i1;
                
                    // Permutations
                    i = mod289(i); // Avoid truncation effects in permutation
                    vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
                        + i.x + vec3(0.0, i1.x, 1.0 ));
                
                    vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
                    m = m*m ;
                    m = m*m ;
                
                    // Gradients: 41 points uniformly over a line, mapped onto a diamond.
                    // The ring size 17*17 = 289 is close to a multiple of 41 (41*7 = 287)
                
                    vec3 x = 2.0 * fract(p * C.www) - 1.0;
                    vec3 h = abs(x) - 0.5;
                    vec3 ox = floor(x + 0.5);
                    vec3 a0 = x - ox;
                
                    // Normalise gradients implicitly by scaling m
                    // Approximation of: m *= inversesqrt( a0*a0 + h*h );
                    m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
                
                    // Compute final noise value at P
                    vec3 g;
                    g.x  = a0.x  * x0.x  + h.x  * x0.y;
                    g.yz = a0.yz * x12.xz + h.yz * x12.yw;
                    return 130.0 * dot(m, g);
                }
                
                vec3 curl(float	x,	float	y,	float	z)
                {
                
                    float	eps	= 1., eps2 = 2. * eps;
                    float	n1,	n2,	a,	b;
                
                    x += uTime * 0.05;
                    y += uTime * 0.05;
                    z += uTime * 0.05;
                
                    vec3	curl = vec3(0.);
                
                    n1	=	noise(vec2( x,	y	+	eps ));
                    n2	=	noise(vec2( x,	y	-	eps ));
                    a	=	(n1	-	n2)/eps2;
                
                    n1	=	noise(vec2( x,	z	+	eps));
                    n2	=	noise(vec2( x,	z	-	eps));
                    b	=	(n1	-	n2)/eps2;
                
                    curl.x	=	a	-	b;
                
                    n1	=	noise(vec2( y,	z	+	eps));
                    n2	=	noise(vec2( y,	z	-	eps));
                    a	=	(n1	-	n2)/eps2;
                
                    n1	=	noise(vec2( x	+	eps,	z));
                    n2	=	noise(vec2( x	+	eps,	z));
                    b	=	(n1	-	n2)/eps2;
                
                    curl.y	=	a	-	b;
                
                    n1	=	noise(vec2( x	+	eps,	y));
                    n2	=	noise(vec2( x	-	eps,	y));
                    a	=	(n1	-	n2)/eps2;
                
                    n1	=	noise(vec2(  y	+	eps,	z));
                    n2	=	noise(vec2(  y	-	eps,	z));
                    b	=	(n1	-	n2)/eps2;
                
                    curl.z	=	a	-	b;
                
                    return	curl;
                }
    
            `
        )
        shader.vertexShader = shader.vertexShader.replace(
            '#include <begin_vertex>',
            `
                #include <begin_vertex>
            
                vec3 noise = 10. * curl(position.x, position.y, position.z);
                transformed += noise;
                
            `
        )

        shader.fragmentShader = shader.fragmentShader.replace(
            'gl_FragColor = vec4( outgoingLight, diffuseColor.a );',
            `
                float r = 0.0, delta = 0.0, alpha = 1.0;
                vec2 cxy = 2.0 * gl_PointCoord - 1.0;
                r = dot(cxy, cxy);
                if (r > 1.0) {
                    discard;
                }
                gl_FragColor = vec4( outgoingLight, alpha * diffuseColor.a );
            `

        )
    }
    const particles = new THREE.Points( fireflyGeometry, fireflyMaterial );
    scene.add( particles );

    /**
     * Renderer
     */
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true,
    })
    renderer.setSize(sizes.width, sizes.height)
    renderer.setClearColor(0x555555, 1)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    textures[0].minFilter = THREE.LinearFilter;
    scene.background = textures[0]
    
    /**
     * Animate
     */
    const clock = new THREE.Clock()
    let lastElapsedTime = 0
    
    const tick = () =>
    {
        const elapsedTime = clock.getElapsedTime()
        const deltaTime = elapsedTime - lastElapsedTime
        lastElapsedTime = elapsedTime

        customUniforms.uTime.value = elapsedTime

        controls.update()

        // Resize Background Image
        const canvasAspect = canvas.clientWidth / canvas.clientHeight;
        const imageAspect = bgTexture.image ? bgTexture.image.width / bgTexture.image.height : 1;
        const aspect = imageAspect / canvasAspect;
        bgTexture.offset.x = aspect > 1 ? (1 - 1 / aspect) / 2 : 0;
        bgTexture.repeat.x = aspect > 1 ? 1 / aspect : 1;
        bgTexture.offset.y = aspect > 1 ? 0 : (1 - aspect) / 2;
        bgTexture.repeat.y = aspect > 1 ? 1 : aspect;

        // Render
        renderer.render(scene, camera)
    
        // Call tick again on the next frame
        window.requestAnimationFrame(tick)
    }
    
    tick()

    // Glitch
    function glitch(){
        var dur = gsap.utils.random(0.0, 0.3);
        var float = gsap.timeline({onComplete:glitch});
        float.to(customUniforms.progress, {
          value: "random(0.2, 0.3)",
          duration: dur,
          repeat:1,
          yoyo:true
        })
               
    }
      
    glitch();
      
}